<template>
	<v-container fluid v-if="lodgings" class="mb-10">
		<v-row>
			<v-col cols="12" sm="6" md="4">
				<v-card outlined>
					<v-card-text>
						<v-menu v-model="menu" :close-on-content-click="false" max-width="290">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									clearable
									dense
									outlined
									filled
									label="Seleccione un mes"
									readonly
									v-bind="attrs"
									v-on="on"
									@click:clear="month = null"
									hide-details
									:value="dateFormatted"
								></v-text-field>
							</template>
							<v-date-picker
								v-model="month"
								@change="menu = false"
								no-title
								type="month"
								locale="es"
							></v-date-picker>
						</v-menu>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="12" sm="6" md="4">
				<v-card outlined>
					<v-card-text>
						<v-text-field
							dense
							hide-details
							label="Nombres o fechas"
							outlined
							filled
							append-icon="mdi-magnify"
							single-line
							v-model="search"
						></v-text-field>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<v-data-table
					:headers="headers"
					:items="items"
					:loading="loading"
					item-key="_id"
					mobile-breakpoint="300"
					:items-per-page="itemsPerPage"
					class="elevation-1"
					no-data-text="Sin registros de asistencia"
					:footer-props="{
						'items-per-page-text': 'Registros por página',
					}"
				>
					<!-- fullname/nombre -->
					<template v-slot:[`item.fullName`]="{ item }">
						<span class="text-capitalize">
							{{ item.person.firstName }} {{ item.person.lastName }}
						</span>
					</template>
					<!-- place/Establecimiento -->
					<template v-slot:[`item.place`]="{ item }">
						<span class="text-capitalize"> {{ item.place }} - {{ item.period }} </span>
					</template>
					<!-- date/fecha -->
					<template v-slot:[`item.date`]="{ item }">
						{{ dateTime(item) }}
					</template>
					<!-- in/Ingreso -->
					<template v-slot:[`item.in`]="{ item }">
						<span v-if="!item.worked">{{ formatDate(item.in) }}</span>
						<span v-else>-</span>
					</template>

					<!-- in/temperature -->
					<template v-slot:[`item.temperature`]="{ item }">
						<span v-if="item.temperature">{{ item.temperature }}</span>
						<span v-else>S/R</span>
					</template>
					<!-- image/foto -->
					<template v-slot:[`item.image`]="{ item }">
						<a
							class="text-capitalize"
							v-if="item.image"
							:href="item.image"
							target="_blank"
						>
							Ver foto
						</a>
						<span v-else>Sin foto</span>
					</template>
					<!-- out/salida -->
					<template v-slot:[`item.out`]="{ item }">
						<span v-if="!item.worked">
							{{ formatDate(item.out) }}
						</span>
						<span v-else>-</span>
					</template>
					<!-- extra/horas extra -->
					<template v-slot:[`item.extra`]="{ item }">
						<span v-if="!item.worked">{{ item.extra }}</span>
						<span v-else>-</span>
					</template>
					<!-- delay/horas de retraso -->
					<template v-slot:[`item.delay`]="{ item }">
						<span v-if="!item.worked">{{ item.delay }}</span>
					</template>
					<!-- durations/duracion entre la entrada y salida -->
					<template v-slot:[`item.durations`]="{ item }">
						<span v-if="!item.worked">{{ durations(item.in, item.out) }}</span>
					</template>
					<!-- total earned/total ganado durante ese dia -->
					<template v-slot:[`item.earned`]="{ item }">
						<template v-if="item.earned">
							<span>{{ item.earned.toFixed(2) }}</span>
							<span class="success--text"> $ </span>
						</template>
						<span v-else>-</span>
					</template>

					<!-- ubications -->
					<template v-slot:[`item.actions`]="{ item }">
						<div v-if="item.worked">Sin ubicaciones</div>
						<template v-else>
							<v-btn color="info" x-small @click="setMap(item.checkIn)">
								<v-icon small left>mdi-map-marker-check</v-icon>
								<span v-if="!isMobile">Ingreso</span>
							</v-btn>
							<v-btn
								color="info"
								x-small
								class="ma-2"
								:disabled="formatDate(item.out) == '-'"
								@click="setMap(item.checkOut)"
							>
								<v-icon small left>mdi-map-marker-check</v-icon>
								<span v-if="!isMobile">Salida</span>
							</v-btn>
						</template>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
		<v-dialog v-model="dialog" width="500" @click:outside="close">
			<v-sheet>
				<v-toolbar dense>
					<span class="title">Ubicación</span>
					<v-spacer></v-spacer>
					<v-btn icon @click="close">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>
				<GeoAssistance v-show="position" :position="position" />
			</v-sheet>
		</v-dialog>
	</v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
let moment = extendMoment(Moment);

export default {
	components: {
		GeoAssistance: () => import('@/components/lodgings/GeoAssistance'),
	},
	props: {
		persons: {
			type: Array,
			default: () => [],
		},
		setPersonsId: { type: Function },
	},
	data() {
		return {
			loading: false,
			unwatch: null,
			idMap: '',
			headers: [
				{ text: 'Nombre', value: 'fullName', align: 'start', sortable: true },
				{ text: 'Establecimiento', value: 'place', sortable: true },
				{ text: 'Fecha', value: 'date', sortable: true },
				{ text: 'Ingreso', value: 'in', sortable: true },
				{ text: 'Temp.', value: 'temperature', sortable: true },
				{ text: 'imagen', value: 'image', sortable: false },
				{ text: 'Salida', value: 'out', sortable: true },
				{ text: 'Horas extra', value: 'extra', sortable: true },
				{ text: 'Horas faltantes', value: 'delay', sortable: true },
				{ text: 'Duración', value: 'durations', sortable: true },
				{ text: 'Ganado', value: 'earned', sortable: true },
				{ text: 'Ubicación', value: 'actions', align: 'end', sortable: false },
			],
			dialog: false,
			position: null,
			search: '',
			itemsPerPage: 30,
			menu: false,
			month: moment()
				.date(1)
				.format('YYYY-MM'),
		};
	},
	computed: {
		items() {
			let endDate = moment(this.month);
			let lodgings = this.lodgings.filter(lod => {
				return lod.histories && lod.histories.length;
			});
			let histories = [];
			let persons = lodgings.map(lod => lod.person);
			persons.forEach(person => {
				if (!person.lodgings) person.lodgings = [];
				lodgings.forEach(lod => {
					if (lod.person._id == person._id) person.lodgings.push(lod);
				});
			});
			lodgings.forEach(lod => {
				lod.histories.map(history => {
					const historyDate = moment(history.in);
					if (historyDate.isSame(endDate, 'month')) {
						histories.push({
							...history,
							person: lod.person,
							place: lod.place.name,
							room: lod.room,
						});
					}
				});
			});

			histories = histories.sort((a, b) => {
				const da = new Date(a.in).getTime();
				const db = new Date(b.in).getTime();

				return db < da ? -1 : db > da ? 1 : 0;
			});
			if (this.search) {
				const personAssitenceFilter = histories.filter(item => {
					let date = moment(item.in).format('DD-MM-YYYY');
					return (
						item.person.firstName.toLowerCase().indexOf(this.search.toLowerCase()) >
							-1 ||
						item.person.lastName.toLowerCase().indexOf(this.search.toLowerCase()) >
							-1 ||
						date.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
						item.place.toLowerCase().indexOf(this.search.toLowerCase()) > -1
					);
				});
				this.setPersonsId(personAssitenceFilter.map(histories => histories.person._id));
				return personAssitenceFilter;
			}
			return histories;
		},
		dateFormatted() {
			return this.month ? moment(this.month).format('MMMM YYYY') : '';
		},
		...mapGetters({
			lodgings: 'Lodging/lodgingsOfPersons',
		}),
	},
	async mounted() {
		this.loading = true;
		await this.getLodgingsOfPerson(this.persons.map(el => el._id));
		this.loading = false;
	},
	methods: {
		durations(start, end) {
			if (end) {
				const diff = moment(end).diff(moment(start));
				return moment.utc(diff).format('HH:mm:ss');
			}
			return '-';
		},
		dateTime(item) {
			return moment(item.in).format('DD-MM-YYYY');
		},
		formatDate(date) {
			if (date) return moment(date).format('LT');
			else return '-';
		},
		setMap(position) {
			this.position = { lat: position[0], lng: position[1] };
			this.dialog = true;
		},
		close() {
			this.position = null;
			this.dialog = false;
		},
		getPerson(id) {
			return this.persons.find(person => person._id == id);
		},
		...mapActions({
			getLodgingsOfPerson: 'Lodging/getLodgingsOfPerson',
		}),
	},
};
</script>
